module.exports = __webpack_public_path__ + "static/media/02 Generali Życie i zdrowie Karta produktu.7206c062.pdf";